export default {
    preferredFrenchCode : 'FrenchCA',
    lob: {
        recVehLine: {
            productCode: 'RecVehProduct',
            coverageTypes: ['coverages', 'addlCoverages', 'conditions', 'exclusions', 'addlInsdCoverages']
        },
    },
    jobTypes: {
        policyChange: 'PolicyChange',
        submission: 'Submission',
        renewal: 'Renewal'
    },
    lobKeys: {
        recVehProduct: 'RecVehProduct',
        proLinProduct : 'ProLinProduct',
        envProduct : 'EnvProduct'
    },
    lineName: {
        RecVehProduct : 'recVehLine',
        ProLinProduct : 'proLine',
        EnvProduct: 'envLin',
        EveLiaProduct : 'eveLiaLine',
        SpoAndRecProduct: 'spoAndRecLine',
        ConsTraAndServProduct: 'consTraAndServLine',
        RecMarProduct: 'recMarLine',
        SpeLinProduct: 'speLinLine',
        SpaAndWelProduct: 'spaAndWellLine',
        CybLiaProduct: 'cybLiaLine',
        PerProduct: 'perLine'
    },
    common: {
        PLEProCovCov: 'PLEProCovCov',
        PSWMisProFloCov: 'PSWMisProFloCov',
        PPLArcMisProFloCov: 'PPLArcMisProFloCov',
        PPLMipMisProFloCov: 'PPLMipMisProFloCov',
        PPLAccMisProFloCov: 'PPLAccMisProFloCov'
    }
    
};